/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import CasesAPI from 'api/CasesAPI';
import UsersAPI from 'api/UsersAPI';
import { useSnackbar } from 'notistack';
import { Redirect, useHistory } from 'react-router-dom';

import DBModuleHeaderLayout from 'components/Common/Layouts/DBModuleHeaderLayout';
import ReviewQueue from 'components/BiteDB/ReviewQueue';

interface TeamKeys {
  name: string;
  id: string;
}
const ReviewQ: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [userHasMonitor, setUserHasMonitor] = useState(false);
  const [selectedCase, setSelectedCase] = useState<any>({});
  const [ownerEmail, setOwnerEmail] = useState('');
  const [autoID, setAutoID] = useState<number>(0);
  const [cur_case, setCase] = useState<{
    isLoaded: boolean;
    error: string | undefined;
    data: any;
  }>({ isLoaded: false, error: undefined, data: {} });

  const requiredTiers = [
    'pro',
    'business',
    'enterprise',
    'database',
    'tariff database',
  ];

  const checkSubscription = () => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      return;
    }
    if (
      requiredTiers.some((role) =>
        cur_user.selected_team?.attributes?.tier.includes(role),
      )
    ) {
      setUserHasMonitor(true);
    }
  };

  useEffect(() => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      return;
    }
    checkSubscription();
  }, [cur_user.quickcodeOnly]);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const getOwner = async (id: string) => {
    const res = await UsersAPI.getUser(id);
    if (res?.success) {
      return res?.result.basics.email;
    }
    return '';
  };

  useEffect(() => {
    const fetchOwner = async () => {
      if (!selectedCase || !selectedCase._id) {
        return;
      }

      CasesAPI.getCase(selectedCase._id)?.then(async (res: any) => {
        if (res?.success) {
          if (
            res.result.owner?.email !== cur_user.basics?.email &&
            !res.result.sharedWith.includes(cur_user.basics?.email) &&
            !res.result.sharedWith.includes(cur_user.basics?.id) &&
            !(res.result.createdBy === cur_user.basics?.id)
          ) {
            history.push('/');
          }

          setCase({ isLoaded: true, error: undefined, data: res.result });

          if (res.result.owner) {
            setOwnerEmail(res.result.owner?.email);
          } else {
            const email = await getOwner(res.result.createdBy);
            setOwnerEmail(email);
          }
        } else {
          const err_text = `Error loading case: ${res?.result}`;
          enqueueSnackbar(err_text, { variant: 'error' });
        }
      });
    };

    fetchOwner();
  }, [selectedCase]);

  useEffect(() => {
    if (props.location.state) {
      const { id } = props.location.state;
      setAutoID(id);
      // fetchDatabases(id);
    }
  }, []);

  const helpContent = (
    <p className='module-header-tooltip-text'>
      Quickly search for high risk people, companies and products as well as
      cyber threat indicators. Filter by Lens for more accuracy
    </p>
  );

  return (
    <DBModuleHeaderLayout
      title='Databases'
      helpContent={helpContent}
      hubLabel='BITE DB'
      hubTo='/bite-db/entities'
    >
      <div>
        <ReviewQueue />
      </div>
    </DBModuleHeaderLayout>
  );
};

export default ReviewQ;
